<template>
  <main role="main" class="container py-5">

    <b-form id="form-test" @submit.prevent="onSubmitForm">
      <b-form-group label="Họ và tên test (*)" label-for="input-person-name">
        <b-form-input id="input-person-name" type="text" v-model="personName" required minlength="2" maxlength="100"/>
      </b-form-group>
    </b-form>

    <b-form-group label="Value to set" label-for="input-value-to-set">
      <b-form-input id="input-value-to-set" type="text" v-model="valueToSet" />
    </b-form-group>

    <div>
      <b-button type="submit" form="form-test" variant="primary" class="mr-3">Submit form</b-button>
      <b-button variant="primary" class="mr-3" @click="personName = valueToSet">Set value</b-button>
    </div>

  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as validationUtils from "@/service/validationUtils";

  @Component
  export default class TestNativeValidate extends BaseComponent {

    personName = "";
    valueToSet = "";


    mounted() {

    }

    onSubmitForm() {

    }


  }
</script>
